import React from "react";
import { Query } from "@apollo/client/react/components";
import { gql } from "@apollo/client";
import { Select } from "antd";
import PageLoader from "../PageLoader";

const MIGRATION_USER_QUERY = gql`
  query userQuery {
    users {
      id
      firstName
      lastName
      email
      active
    }
  }
`;

const { Option } = Select;

type UserSelectProps = {
  onChange?: any;
  value?: string;
};

export default class UserSelect extends React.Component<UserSelectProps> {
  userSelectOptions(users: any[]): JSX.Element[] {
    let options = [];
    if (users) {
      users.forEach((user) => {
        options.push(
          <Option value={user.id} key={user.id}>
            {user.firstName} {user.lastName}
          </Option>,
        );
      });
    }
    return options;
  }

  render() {
    return (
      <Query query={MIGRATION_USER_QUERY}>
        {({ loading, data }) => {
          if (loading) {
            return <PageLoader tip="Loading..." delay={500} />;
          }

          return (
            <Select
              showSearch
              key="userId"
              optionFilterProp="children"
              value={this.props.value}
              onChange={this.props.onChange}
              filterOption={(input, option) =>
                option.props.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {this.userSelectOptions(
                data.users?.filter((user) => user.active),
              )}
            </Select>
          );
        }}
      </Query>
    );
  }
}
